import Entity from './entity'
import Post from './post'
export default class Page extends Entity<number>{
    pageTitle:string;
    posts:Array<Post>;
    tenantId:number;

    constructor() {
    	super();
  	}
}